"use strict";

function ajaxTrans(closure) {
  var xhrFields = closure.xhrFields;
  var url = closure.url;
  var type = closure.type;
  var dataType = closure.dataType;
  var data = eval('(' + closure.data + ')');
  var async = closure.async;
  var headers = closure.headers;
  var token = "";
  var frontKey = "";
  var frontPriKey = ""; // var sessionStorage = window.sessionStorage;

  var localStorage = window.localStorage; //获取登陆的前端密钥

  if (sessionStorage.length > 0) {
    frontKey = sessionStorage.getItem("frontPubKey");
  } //获取cookie


  var strcookie = document.cookie; //获取cookie字符串

  var arrcookie = strcookie.split("; "); //分割

  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");

    if (arr[0] == "reqSeries") {
      token = arr[1];
    }
  } //加密令牌


  if (token != "") {
    token = encryptbySM2(token, frontKey);
  }

  data.token = token;

  if (window.localStorage.getItem("frontPriKey")) {
    frontPriKey = window.localStorage.getItem("frontPriKey");
  }

  $.ajax({
    xhrFields: xhrFields,
    url: url,
    type: type,
    dataType: dataType,
    data: JSON.stringify(data),
    async: async,
    headers: headers,
    success: function success(data) {
      if (data.code && (data.code === 'TO.LOGIN' || data.code === '0003')) {
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.href = logoutUrl;
      }

      var result = decryptbySM2(data, frontPriKey);
      closure.success(JSON.parse(result));
    },
    error: function error(data) {
      if (data.status == 500) {
        if (typeof data.responseJSON.code != "undefined" && data.responseJSON.code != null) {
          switch (data.responseJSON.code) {
            case 5555:
              errorAlert("登录状态异常，请重新登录！");
              window.top.location.href = tokenUrl;
              break;

            case 5556:
              errorAlert(data.responseJSON.msg);
              break;

            case 5557:
              errorAlert(data.responseJSON.msg.errorMsg);
              window.top.location.href = rootUrl + data.responseJSON.msg.redirectUrl;
              break;

            default:
              errorAlert("系统异常，稍后再试！");
              break;
          }
        }
      } else {
        errorAlert("系统异常，稍后再试！");
      }

      closure.error(data);
      return false;
    }
  });
}